import React, { useMemo } from 'react'
import { Table, Tag } from 'antd'
import { TAX_YEARS } from '../../constants/taxConstants'

export default function BandTable({ taxYear = '2024/2025', isScottish = false }) {
  const data = useMemo(() => {
    const year = TAX_YEARS[taxYear]
    if (!year) return { taxBands: [], nic: null }

    if (isScottish) {
      const s = year.SCOTLAND
      const taxBands = [
        { key: 'starter', band: 'Starter', upTo: s.STARTER_RATE_LIMIT, rate: `${Math.round(s.STARTER_RATE * 100)}%` },
        { key: 'basic', band: 'Basic', upTo: s.BASIC_RATE_LIMIT, rate: `${Math.round(s.BASIC_RATE * 100)}%` },
        { key: 'intermediate', band: 'Intermediate', upTo: s.INTERMEDIATE_RATE_LIMIT, rate: `${Math.round(s.INTERMEDIATE_RATE * 100)}%` },
        { key: 'higher', band: 'Higher', upTo: s.HIGHER_RATE_LIMIT, rate: `${Math.round(s.HIGHER_RATE * 100)}%` },
        { key: 'advanced', band: 'Advanced', upTo: s.ADVANCED_RATE_LIMIT || s.HIGHER_RATE_LIMIT, rate: s.ADVANCED_RATE ? `${Math.round(s.ADVANCED_RATE * 100)}%` : '-' },
        { key: 'top', band: 'Top', upTo: 'No limit', rate: `${Math.round(s.TOP_RATE * 100)}%` },
      ]
      return {
        taxBands,
        nic: year.UK,
      }
    } else {
      const u = year.UK
      const taxBands = [
        { key: 'basic', band: 'Basic', upTo: u.TAX_BASIC_RATE_LIMIT, rate: `${Math.round(u.TAX_BASIC_RATE * 100)}%` },
        { key: 'higher', band: 'Higher', upTo: u.TAX_HIGHER_RATE_LIMIT, rate: `${Math.round(u.TAX_HIGHER_RATE * 100)}%` },
        { key: 'additional', band: 'Additional', upTo: 'No limit', rate: `${Math.round(u.TAX_ADDITIONAL_RATE * 100)}%` },
      ]
      return {
        taxBands,
        nic: u,
      }
    }
  }, [taxYear, isScottish])

  const columns = [
    { title: 'Band', dataIndex: 'band', key: 'band', render: (t) => <Tag color="blue">{t}</Tag> },
    { title: 'Upper limit', dataIndex: 'upTo', key: 'upTo' },
    { title: 'Rate', dataIndex: 'rate', key: 'rate' },
  ]

  return (
    <div>
      <Table
        size="small"
        columns={columns}
        dataSource={data.taxBands}
        pagination={false}
        style={{ marginBottom: 12 }}
      />
      {data.nic && (
        <div style={{ fontSize: 12, color: '#666' }}>
          NIC thresholds: Primary {data.nic.NIC_PRIMARY_THRESHOLD?.toLocaleString?.() || data.nic.NIC_PRIMARY_THRESHOLD}, Upper Earnings Limit {data.nic.NIC_UPPER_EARNINGS_LIMIT?.toLocaleString?.() || data.nic.NIC_UPPER_EARNINGS_LIMIT}. NIC rates: Lower {Math.round((data.nic.NIC_LOWER_RATE || 0) * 100)}%, Upper {Math.round((data.nic.NIC_UPPER_RATE || 0) * 100)}%
        </div>
      )}
    </div>
  )
}
